module.exports = __webpack_public_path__ + "img/x-axis.e7445e4d.svg";